var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content-wrapper" },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("tables.tables"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.search") },
                  on: { input: _vm.onSearch },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$feature.beforeCreateTable(_vm.createTable)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.newTable")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "ai-suggest-button",
                    on: { click: _vm.showWizard },
                  },
                  [
                    _c("img", {
                      staticClass: "copilot-icon",
                      attrs: { src: "/static/img/copilot.png" },
                    }),
                    _vm._v(
                      "\n                    Supsis Asistan ile Uygulama Oluştur\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.paginatedTables,
              "top-pagination": true,
              "empty-data-bordered": "",
              "bottom-pagination": false,
              "pagination-cursor": _vm.pagination,
              options: {
                rowStyleOption: _vm.rowStyleOption,
                clipboardOption: _vm.clipboardOption,
                fixedHeader: true,
                id: "tables-table",
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCreateModal
        ? _c(
            "Modal2",
            {
              attrs: { showFooter: false, title: _vm.$t("tables.createTable") },
              on: {
                cancel: function ($event) {
                  _vm.showCreateModal = false
                },
              },
            },
            [_c("CreateTable", { on: { create: _vm.handleCreateTable } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditModal
        ? _c(
            "Modal2",
            {
              attrs: { showFooter: false, title: _vm.$t("tables.editTable") },
              on: {
                cancel: function ($event) {
                  _vm.showEditModal = false
                },
              },
            },
            [
              _c("EditTable", {
                attrs: { table: _vm.editingTable },
                on: { update: _vm.handleUpdateTable },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTableAiWizard
        ? _c("TableAiWizard", {
            on: {
              "table-added": _vm.tableAdded,
              close: function ($event) {
                _vm.showTableAiWizard = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }